import Image from "next/image";
import Link from "next/link";
import { ArrowRightCircle } from "lucide-react";
import { BlockProps } from "../BlocksManager/registry";
import HeroTitle from "../HeroTitle";

function renderMarkedTitle(title: string, highlightClass: string) {
  const parts = title.split(/(\[.*?\])/g);

  return parts.map((part, index) => {
    const isHighlighted = part.startsWith("[") && part.endsWith("]");

    if (isHighlighted) {
      const text = part.slice(1, -1);

      return (
        <span
          key={index}
          className={`inline-block font-heading -rotate-1 rounded-lg my-2 uppercase tracking-widest px-3 py-0.5 text-[32px] lg:text-[40px]  text-white ${highlightClass}`}
        >
          {text}
        </span>
      );
    }

    return <span key={index}>{part}</span>;
  });
}

export default function DevenirPartenaire({ data }: BlockProps) {
  if (!data) return null;
  const features = data.avantages || [];
  return (
    <section className="relative overflow-hidden bg-violet-semi-light pt-12 pb-0 lg:pt-20 md:min-h-[600px] lg:min-h-[650px]" key={data.id}>

      {/* Cercles décoratifs — cachés sur mobile */}
      <div className="hidden md:block absolute z-1 -bottom-30 left-[40%] h-80 w-80 rounded-full bg-violet lg:h-[350px] lg:w-[350px]" />
      <div className="hidden md:block absolute -top-10 right-24 h-24 w-24 rounded-full bg-violet" />
      <div className="hidden md:block absolute top-14 -right-12 h-48 w-48 rounded-full bg-violet lg:h-56 lg:w-56" />
      <div className="hidden md:block absolute bottom-0 left-[58%] h-16 w-16 rounded-full bg-violet" />

      {/* Image desktop — absolue à droite */}
      <div className="absolute right-0 top-0 hidden h-full w-[54%] lg:block">
        <Image
          src={data.image.url}
          alt={data.imageAlt || "Illustration partenaire"}
          fill
          className="object-cover object-left-top"
          priority
        />
      </div>

      <div className="relative z-10 mx-auto max-w-[1700px]  container">
        <div className="lg:max-w-[55%]">
          <h2 className="font-literata text-[32px] lg:text-[60px] font-bold leading-[1.25] text-text-body  ">
              {renderMarkedTitle(data.titre, "bg-pink")}
            </h2>
          

          <p className="mt-4 max-w-[600px] font-body text-[18px] font-medium leading-[1.35] text-black md:text-[24px]">
            {data.description}
          </p>

          {/* Features */}
          <div className="mt-6 flex w-full flex-col gap-3 rounded-2xl bg-white p-4 shadow-sm md:flex-row md:items-stretch md:gap-0 md:rounded-[18px]">
            {features.map((item, index) => (
              <div
                key={item.id}
                className={`flex items-center gap-3 px-3 py-2 ${index < features.length - 1
                  ? "border-b border-black/10 pb-3 md:border-b-0 md:border-r md:pb-2"
                  : ""
                  }`}
              >
                <div className="relative h-10 w-10 shrink-0">
                  <Image
                    src={item.icon.url}
                    alt={item.iconAlt || item.label}
                    fill
                    className="object-contain"
                  />
                </div>
                <p className="text-sm leading-[1.25] text-black md:text-[15px]">
                  {item.label}
                </p>
              </div>
            ))}
          </div>

          <div className="my-6 md:mt-8">
            <Link
              href={data.cta.link}
              className="inline-flex items-center gap-3 rounded-full bg-yellow px-6 py-3.5 text-[16px] font-semibold text-black transition hover:opacity-90 md:px-7 md:py-4 md:text-[22px]"
            >
              {data.cta.text}
              <ArrowRightCircle className="h-5 w-5 md:h-6 md:w-6" />
            </Link>
          </div>
        </div>

        {/* Image mobile */}

        
      </div>
    </section>
  );
}